module.exports = __webpack_public_path__ + "static/img/home.19062a97.png";